// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"rec-import_paragraph__1ZeuW","btn":"rec-import_btn__1icKU","borderContainer":"rec-import_borderContainer__zt40T"};